import moment from 'moment'

export const GOAL_REACHED_WEEKLY = 'weekly'
export const GOAL_REACHED_NONE = 'none'

export const STORAGE_GOAL_WEEKLY = 'goalWeeklyCelebratedAt'

export const getGoalReachedState = (weeklyGoals) => {
  const isWeeklyGoalReached = weeklyGoals?.completeFraction >= 100

  if (isWeeklyGoalReached) {
    return GOAL_REACHED_WEEKLY
  }

  return GOAL_REACHED_NONE
}

export const shouldShowCelebrations = (goalReached) => {
  return [GOAL_REACHED_WEEKLY].includes(
    goalReached
  )
}

export const getDate = (storageKey) => {
  if (!window.localStorage) {
    return null
  }

  const value = window.localStorage.getItem(storageKey)

  if (!value) {
    return null
  }

  const date = moment(Number(value))

  return date.isValid() ? date : null
}

// The logic here is to make it appear only once per day for daily celebrations and once per week for weekly celebrations.
export const hasUserAlreadySeenCelebration = (goalReached) => {
  if (
    !window.localStorage ||
    !goalReached ||
    goalReached === GOAL_REACHED_NONE
  ) {
    return false
  }

  const weeklyGoalCelebratedAt = getDate(STORAGE_GOAL_WEEKLY)
  const now = new Date().getTime()

  return weeklyGoalCelebratedAt
    ? weeklyGoalCelebratedAt.isSame(now, 'week')
    : false
}

export const persistCelebratedGoal = (goalReached) => {
  if (
    !window.localStorage ||
    !goalReached ||
    goalReached === GOAL_REACHED_NONE
  ) {
    return
  }

  const now = new Date().getTime()

  // weekly
  if (
    goalReached === GOAL_REACHED_WEEKLY
  ) {
    window.localStorage.setItem(STORAGE_GOAL_WEEKLY, String(now))
  }
}
